//Reducers
import linkServiceReducers from './linkService/linkServiceReducers';
//Actions
import * as actions from './agencyActions';

// Helpers
import { getAgencySlugByCode, getAppSlugByCodes } from '../../lib/helpers';

const agencyReducers = {
  [actions.AGENCY_STORE_ALL_APPS]: (state, { payload }) => {
    payload.forEach(({ agencyId, agencyCode, agencyName, ...app }) => {
      const agency = { agencyId, agencyCode, agencyName };

      if (!state.agencies[agencyId]) state.agencies[agencyId] = agency;
      if (!state.agencies[agencyId].appIds)
        state.agencies[agencyId].appIds = [];

      state = storeAgencyApp(state, { agency, app });
    });
    return state;
  },
  [actions.AGENCY_STORE_MY_APPS]: (state, { payload }) => {
    payload.forEach(({ apps, ...agency }) => {
      state = storeAgency(state, { agency });

      state.agencies[agency.agencyId].appIds = [];
      state.agencies[agency.agencyId].linkUserKeys = [];

      apps.forEach(({ links, ...app }) => {
        state = storeAgencyApp(state, { agency, app });

        if (links && links.length) {
          links.forEach(link => {
            state = storeAgencyLink(state, { agency, app, link });
          });
        }
      });
    });
    return state;
  },
  [actions.AGENCY_STORE_AGENCY]: (state, { payload: { apps, ...agency } }) => {
    state = storeAgency(state, { agency });

    state.agencies[agency.agencyId].appIds = [];
    state.agencies[agency.agencyId].linkUserKeys = [];

    apps.forEach(({ links, ...app }) => {
      state = storeAgencyApp(state, { agency, app });

      state.apps[app.appId].linkUserKeys = [];

      if (links && links.length) {
        links.forEach(link => {
          state = storeAgencyLink(state, { agency, app, link });
        });
      }
    });

    return state;
  },
  [actions.AGENCY_STORE_LINK]: (
    state,
    { payload: { agencyId, agencyName, appCode, appId, appName, userKey } }
  ) => {
    const data = {
      agency: { agencyId, agencyName },
      app: { appCode, appId, appName },
      link: { userKey },
    };

    storeAgencyLink(state, data);

    return state;
  },
  [actions.AGENCY_UPDATE_LINK_DATA]: (state, { payload: links }) => {
    links.forEach(link => {
      link.profiles.forEach(profile => {
        state.links[profile.userKey].profile = profile;
      });
    });
    return state;
  },
  [actions.AGENCY_REMOVE_LINK_BY_USERKEY]: (state, { payload: link }) => {
    delete state.links[link.userKey];
    state.agencies[link.agencyId].linkUserKeys = state.agencies[
      link.agencyId
    ].linkUserKeys.filter(userKey => userKey !== link.userKey);
    state.apps[link.appId].linkUserKeys = state.apps[
      link.appId
    ].linkUserKeys.filter(userKey => userKey !== link.userKey);
    state.linkUserKeys = state.linkUserKeys.filter(
      userKey => userKey !== link.userKey
    );
    return state;
  },
  [actions.AGENCY_CLEAR_DATA]:  (state) => {
      return {
        ...state,
        linkUserKeys: [],
        agencies: {},
        links: {},
      };
    }
};

function storeAgency(state, { agency }) {
  const agencyId = agency.agencyId;

  if (!state.agencies) state.agencies = {};
  if (!state.agencyIds) state.agencyIds = [];

  if (!state.agencyIds.includes(agencyId)) state.agencyIds.push(agencyId);
  state.agencies[agencyId] = { ...state.agencies[agencyId], ...agency };

  state.agencies[agencyId].agencySlug = getAgencySlugByCode(agency.agencyCode);

  return state;
}

function storeAgencyApp(state, { agency, app }) {
  const agencyId = agency.agencyId;
  const appId = app.appId;

  app.agencyId = agencyId;

  if (!state.apps) state.apps = {};
  if (!state.appIds) state.appIds = [];
  if (!state.agencies[agencyId].appIds) state.agencies[agencyId].appIds = [];

  if (!state.appIds.includes(appId)) state.appIds.push(appId);
  if (!state.agencies[agencyId].appIds.includes(appId))
    state.agencies[agencyId].appIds.push(appId);

  state.apps[appId] = { ...state.apps[appId], ...app };

  state.apps[appId].appSlug = getAppSlugByCodes(agency.agencyCode, app.appCode);
  state.apps[appId].linkUserKeys = [];

  return state;
}

function storeAgencyLink(state, { agency, app, link }) {
  const agencyId = agency.agencyId;
  const appId = app.appId;
  const userKey = link.userKey;

  if (!state.links) state.links = {};
  if (!state.linkUserKeys) state.linkUserKeys = [];
  if (!state.apps[appId].linkUserKeys) state.apps[appId].linkUserKeys = [];
  if (!state.agencies[agencyId].linkUserKeys)
    state.agencies[agencyId].linkUserKeys = [];

  if (!state.linkUserKeys.includes(userKey)) state.linkUserKeys.push(userKey);
  if (!state.apps[appId].linkUserKeys.includes(userKey))
    state.apps[appId].linkUserKeys.push(userKey);
  if (!state.agencies[agencyId].linkUserKeys.includes(userKey))
    state.agencies[agencyId].linkUserKeys.push(userKey);

  link.agencyId = agencyId;
  link.appId = appId;
  state.links[userKey] = { ...state.links[userKey], ...link };

  return state;
}

export default {
  name: 'agency',
  reducers: { ...agencyReducers, ...linkServiceReducers },
  persist: {
    key: 'agency',
    whitelist: ['link'],
  },
};
